module.exports = __webpack_public_path__ + "static/media/imi.2ed716b4.png";